const ITEMS = [
  "Paris",
  "Île-de-France",
  "Estimation de prestige",
  "Transactions réelles DVF",
  "Appartements haussmanniens",
  "Maisons & hôtels particuliers",
  "Rapport documenté",
  "Conseiller dédié",
];

export default function EditorialMarquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-[#D4AF37]/15 bg-[#0B0B0D] py-5"
    >
      <div className="marquee-track">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display px-8 text-xl italic text-stone-500">{item}</span>
                <span className="text-[#D4AF37]/60">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
